import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLetterASquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"letter-a-square, key"} maskId="square-filled-radius-0-stroke-1-IconLetterASquare"><path d="M12.0469 9.10742L13.3711 12.8809H10.6289L11.9531 9.10742H12.0469Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.4785 7.74219L8.36133 16.1973H9.46875L10.3184 13.7773H13.6816L14.5312 16.1973H15.6387L12.5215 7.74219H11.4785Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLetterASquare;
